import React, { useMemo } from 'react';

import { AFFILIATE_TEXT_BOTTOM } from '../../constants/AffiliatePageText';

import AffiliateDetail from './AffiliateDetail';


function AffiliatePageBottom() {

  const renderAffiliateDetails = useMemo(() => AFFILIATE_TEXT_BOTTOM.map((detail) => (

    <div
      key={detail.title}
      className="content-bg flex justify-center items-center"
      style={{ backgroundImage: `url(${detail.backgroundImageMobile})` }}
    >
      <AffiliateDetail
        desc={detail.desc}
        logo={detail.logo}
      />
    </div>
  )), []);

  return (
    <div className="affiliate container bottom-section">
      <div className="flex justify-around items-center content details">
        {renderAffiliateDetails}
      </div>
    </div>
  );
}

export default AffiliatePageBottom;
